import { subscriptionTypesMap } from '@/data/type-maps';
import { useAuthStore } from '@/stores/auth.ts';
import { watch } from 'vue';
export default {
    beforeMount(el) {
        const authStore = useAuthStore();
        watch(() => authStore.company, () => {
            if (shouldRestrict()) {
                setDisabledAttribute(el);
            }
            else {
                el.removeAttribute('disabled');
            }
        });
        if (shouldRestrict()) {
            setDisabledAttribute(el);
        }
    },
};
function setDisabledAttribute(el) {
    el.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
    });
    if (el.firstChild) {
        el.firstChild.addEventListener('click', (event) => {
            event.stopPropagation();
            event.preventDefault();
        });
    }
    el.setAttribute('disabled', 'disabled');
}
function shouldRestrict() {
    var _a, _b, _c, _d, _e;
    const authStore = useAuthStore();
    if (((_b = (_a = authStore.user) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.subscription.tag) === subscriptionTypesMap.free && ((_d = (_c = authStore.user) === null || _c === void 0 ? void 0 : _c.permissions) === null || _d === void 0 ? void 0 : _d.subscription.is_trial_user)) {
        return true;
    }
    return Boolean(((_e = authStore.user) === null || _e === void 0 ? void 0 : _e.is_employee) && !authStore.user.permissions.subscription.employees);
}
export { shouldRestrict };
